import { Grid, TextField, Button } from '@mui/material';
import { ChangeEvent, Dispatch, SetStateAction, useState } from 'react';
import { WeatherWall } from 'types';
import { useUpdateWeatherWall } from './api/updateWeatherWall';
import { WeatherWallGrid } from './types';

interface Props {
  currentGridWithChanges: WeatherWallGrid;
  setCurrentGridWithChanges: Dispatch<SetStateAction<WeatherWallGrid>>;
  wall: WeatherWall;
}
const EditWallToolbar = ({
  currentGridWithChanges,
  setCurrentGridWithChanges,
  wall,
}: Props) => {
  const updateWeatherWall = useUpdateWeatherWall({});
  const [hasChanges, setHasChanges] = useState(false);
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;

    if (name === 'name') {
      setCurrentGridWithChanges({
        ...currentGridWithChanges,
        [name]: value,
      });
    } else {
      let numValue = parseInt(value);
      if (isNaN(numValue)) {
        setCurrentGridWithChanges({
          ...currentGridWithChanges,
          [name]: value,
        });
        return;
      }
      if (name === 'columns' && numValue > 4) {
        numValue = 4;
      }
      if (name === 'rows' && numValue > 50) {
        numValue = 50;
      }
      setCurrentGridWithChanges({
        ...currentGridWithChanges,
        [name]: numValue,
      });
    }
    setHasChanges(true);
  };

  const handleSubmit = async () => {
    if (!wall) return;
    const updatedWall = {
      ...wall,
      name: currentGridWithChanges.name,
      rows: currentGridWithChanges.rows,
      columns: currentGridWithChanges.columns,
    };
    await updateWeatherWall.mutateAsync({
      data: updatedWall,
      wallId: updatedWall.id,
    });
    setHasChanges(false);
  };
  return (
    <Grid container alignItems='center' spacing={2}>
      <Grid item>
        <TextField
          id='name'
          name='name'
          label='Name'
          value={currentGridWithChanges.name}
          onChange={handleChange}
        />
      </Grid>
      <Grid item>
        <TextField
          id='rows'
          name='rows'
          label='Rows'
          value={currentGridWithChanges.rows}
          onChange={handleChange}
        />
      </Grid>
      <Grid item>
        <TextField
          id='columns'
          name='columns'
          label='Columns'
          value={currentGridWithChanges.columns}
          onChange={handleChange}
        />
      </Grid>
      <Grid item xs={2}>
        <Button
          onClick={handleSubmit}
          color='primary'
          variant='contained'
          fullWidth
          disabled={!hasChanges}
        >
          Save
        </Button>
      </Grid>
      <Grid item xs={12} />
    </Grid>
  );
};

export default EditWallToolbar;
